import { type Context, useContext } from "react";

export interface UseRequiredContextOptions {
	providerName: string;
}

export function useRequiredContext<TValue>(
	context: Context<null | TValue> | Context<undefined | TValue> | Context<null | undefined | TValue>,
	{ providerName }: UseRequiredContextOptions,
): NonNullable<TValue> {
	const value = useContext(context as Context<null | undefined | TValue>);

	if (value != null) {
		return value;
	}

	throw new Error(`Expecting <${providerName}> in the component tree`);
}
